<template>
  <dashboard-widget title="EXCISE LIABILITY" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardExciseLiability')"
                      @delete="$emit('delete','DashboardExciseLiability')"
                      @close="$emit('close')">
    <div ref="chart"/>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardExciseLiability',
  props: {
    width: {type:Number, required:false, default:290},
    zoomed: {type:Boolean, required:false, default:false},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      exciseLiability: [],
      chart: null,
			options: {chartArea:{left:50,height:'75%',width:'85%'},
                isStacked:true,
                colors:['orange','red'],
                height:this.zoomed?440:250,
                fontSize:this.zoomed?12:10,
                hAxis:{title:'Amount Due',format:'$#,###',viewWindowMode:"maximized"},
                vAxis:{},
								legend:{ position: "none"}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['corechart']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.BarChart(this.$refs.chart);
        this.refresh();
        google.visualization.events.addListener(this.chart, 'select', () => {
          const selectedItem = this.chart.getSelection()[0];
          if (selectedItem)
            this.$router.push({name:'ReportsView', params:{back:[{text:'Dashboard',to:{name:'Dashboard'}}]},
                              query:{to:`reports/excise/ReportsExcise${selectedItem.column === 1 ? 'Spirits' : 'Warehouse'}`,
                                    month:this.exciseLiability[selectedItem.row].yyyymm}});
        });
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardExciseLiability {
                                            exciseLiability {
                                              month,yyyymm,warehouse,spirits
                                            }
                                          }`, {});
      if (!results.error) {
        this.exciseLiability = results.data.exciseLiability;
        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      const data = [
        ['Month','Spirits','Warehouse']
      ];
      for (const excise of this.exciseLiability)
        data.push([excise.month,excise.spirits,excise.warehouse]);
      const dataTable = window.google.visualization.arrayToDataTable(data);

      const textColor = {color:this.darkMode?'#ffffff':'#3d3d3d'};
      this.options.hAxis.textStyle = textColor;
      this.options.hAxis.titleTextStyle = textColor;
      this.options.vAxis.textStyle = textColor;
      this.options.vAxis.baselineColor = this.darkMode?'#ffffff':'#3d3d3d';
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(dataTable, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    }
  }
}
</script>